import { request } from "./request";

const BASE_URL = "/api/email/confirmation";

export default {
  async resend_confirmation() {
    return await request({ url: BASE_URL, method: "POST" });
  },
};
